import { render, staticRenderFns } from "./subTable.vue?vue&type=template&id=1100014d&"
import script from "./subTable.vue?vue&type=script&lang=js&"
export * from "./subTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/sub/subTable.vue"
export default component.exports